import React, { useState, useEffect } from "react";
import { Grid, Backdrop, CircularProgress, Fab } from "@material-ui/core";
import useStyles from "../styles";
import PageTitle from "../../../components/PageTitle";
import { jwtDecode } from "jwt-decode";
import { useHistory } from "react-router-dom";
import { Typography } from "../../../components/Wrappers";

import Companies from '../../../images/icon/Companies.png';
import New from '../../../images/icon/New.png';
import emailIcon from '../../../images/icon/emails.png';
import FinalInterview from '../../../images/icon/FinalInterview.png';
import DocumentCollected from '../../../images/icon/DocumentCollected.png';
import FinalInterviewComplete from '../../../images/icon/FinalInterviewComplete.png';
import InterviewScheduled from '../../../images/icon/InterviewScheduled.png';
import Joined from '../../../images/icon/Joined.png';
import Offered from '../../../images/icon/Offered.png';
import SalaryBreakup from '../../../images/icon/SalaryBreakup.png';
import ScheduleInterview from '../../../images/icon/ScheduleInterview.png';
import YetToJoin from '../../../images/icon/YetToJoin.png';
import WorkFlow from '../../../images/gallery/RefoWorkFlow.png'
import WorkFlowRC from '../../../images/gallery/RefoWorkFlowRc.jpg'

export default function FreelancerDashboard({ candidateCounts }) {

    const classes = useStyles();
    const history = useHistory();

    const freelancerListItems = [
        {
            id: "01",
            colorName: classes.blue,
            categoryTitle: "New Candidates",
            categoryImage: New,
            categoryIconColor: classes.blueIcon,
            path: "/app/freelancer_candidates_new",
            statusCode: "status301_count"
        },
        {
            id: "02",
            colorName: classes.purple,
            categoryTitle: "Submitted to Hiring Manager",
            categoryImage: emailIcon,
            categoryIconColor: classes.purpleIcon,
            path: "/app/freelancer_candidates_stc",
            statusCode: "status303_count"
        },
        {
            id: "03",
            colorName: classes.red2,
            categoryTitle: "Schedule Interview",
            categoryImage: ScheduleInterview,
            categoryIconColor: classes.red2Icon,
            path: "/app/freelancer_candidates_schedule_interview",
            statusCode: "status3031_count"
        },
        {
            id: "04",
            colorName: classes.orange,
            categoryTitle: "Interview Scheduled",
            categoryImage: InterviewScheduled,
            categoryIconColor: classes.orangeIcon,
            path: "/app/freelancer_candidates_interview_scheduled",
            statusCode: "status304_count"
        },
        {
            id: "05",
            colorName: classes.teal,
            categoryTitle: "Final Interview Scheduled",
            categoryImage: FinalInterview,
            categoryIconColor: classes.tealIcon,
            path: "/app/freelancer_candidates_fis",
            statusCode: "status3041_count"
        },
        {
            id: "06",
            colorName: classes.blueGrey,
            categoryTitle: "Final Interview Completed",
            categoryImage: FinalInterviewComplete,
            categoryIconColor: classes.blueGreyIcon,
            path: "/app/freelancer_candidates_fic",
            statusCode: "status305_count"
        },
        {
            id: "07",
            colorName: classes.indigo,
            categoryTitle: "Document Collected",
            categoryImage: DocumentCollected,
            categoryIconColor: classes.indigoIcon,
            path: "/app/freelancer_candidates_document_collected",
            statusCode: "status306_count"
        },
        {
            id: "08",
            colorName: classes.pink,
            categoryTitle: "Salary Breakup Shared",
            categoryImage: SalaryBreakup,
            categoryIconColor: classes.pinkIcon,
            path: "/app/freelancer_candidates_salary_breakup_shared",
            statusCode: "status307_count"
        },
        {
            id: "09",
            colorName: classes.deepOrange,
            categoryTitle: "Offered",
            categoryImage: Offered,
            categoryIconColor: classes.deepOrangeIcon,
            path: "/app/freelancer_candidates_offered",
            statusCode: "status308_count"
        },
        {
            id: "10",
            colorName: classes.brown,
            categoryTitle: "Yet to Join",
            categoryImage: YetToJoin,
            categoryIconColor: classes.brownIcon,
            path: "/app/freelancer_candidates_yet_to_join",
            statusCode: "status3081_count"
        },
        {
            id: "11",
            colorName: classes.green,
            categoryTitle: "Joined",
            categoryImage: Joined,
            categoryIconColor: classes.greenIcon,
            path: "/app/freelancer_candidates_joined",
            statusCode: "status309_count"
        },
    ]

    return (
        <>
            {freelancerListItems.map(({ id, colorName, categoryTitle, categoryImage, categoryIconColor, path, statusCode }) =>
                <Grid key={id} item lg={2} xl={2} md={3} sm={4} xs={12} onClick={() => { history.push(path) }} >
                    <div className={colorName} style={{ height: "100%", position: "relative" }}>
                        <div className={classes.visitsNumberContainer}>
                            <Grid container item>
                                <Grid item xs={12}>
                                    <p className={classes.grid_title}>{categoryTitle}</p>
                                </Grid>
                                <Grid item xs={12} className={classes.M10} >
                                    <Typography size="xl" weight="medium" noWrap className={classes.count} style={{ minHeight: "55px" }}>
                                        {candidateCounts[statusCode] || 0}
                                    </Typography>
                                </Grid>

                                <Grid item className={classes.M10} style={{ position: "absolute", right: "12px", bottom: "12px" }}   >
                                    <Fab className={categoryIconColor} aria-label="dashboard">
                                        <img className={classes.w25} src={categoryImage} alt="New Candidates" />
                                    </Fab>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </Grid>
            )}
        </>
    )
}